<template>
  <Radio class="ts-radio" v-bind="$attrs" v-on="$listeners"><slot></slot></Radio>
</template>

<style lang="scss" scoped>
.ts-radio::v-deep {
  .el-radio__input {
    .el-radio__inner {
      background: #ebecf0;
      background-image: linear-gradient(-42deg, #000000 0%, #ffffff 100%);
      background-blend-mode: soft-light, normal;
      background-clip: padding-box;
      border: 1px solid rgba(255, 255, 255, 0.32);
      box-shadow: inset -8px -8px 16px 0 #fafbff, inset 8px 8px 16px 0 #a6abbd, -2px -2px 6px 0 rgba(250, 251, 255, 0.8),
        2px 2px 6px 0 rgba(166, 171, 189, 0.48);
      border-radius: 8px;

      width: 16px;
      height: 16px;
    }
  }

  .el-radio__label {
    font-family: Roboto;
    font-size: 12px;
    color: #6d7587;
    font-weight: normal;
  }

  &.is-checked {
    .el-radio__input {
      .el-radio__inner {
        border-radius: 8px;
        box-shadow: inset 0 -4px 8px 0 rgba(235, 255, 247, 0.88), inset 0 4px 8px 0 rgba(24, 122, 92, 0.4),
          -2px -2px 6px 0 rgba(250, 251, 255, 0.8), 2px 2px 6px 0 rgba(166, 171, 189, 0.48);
        border: solid 1px rgba(235, 236, 240, 0.24);
        background-color: #99ffd1;
      }
    }

    .el-radio__label {
      color: #242424;
    }
  }
}
</style>

<script>
import { Radio } from 'element-ui';

export default {
  name: 'TsRadio',
  components: {
    Radio
  }
};
</script>
